// took from https://stackoverflow.com/a/2117523
import { BINARY_NUMBER_3, BINARY_NUMBER_8, NUMBER_0, NUMBER_16 } from '~shared/constants';

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    // eslint-disable-next-line no-bitwise, no-magic-numbers
    const r = Math.random() * NUMBER_16 | NUMBER_0, v = c === 'x' ? r : (r & BINARY_NUMBER_3 | BINARY_NUMBER_8);
    return v.toString(NUMBER_16);
  });
}
